import { BoxProps, TextProps } from '@jfs/ui-new'
import { ViewStyle } from 'react-native'
import { Colors } from '../../util/util'

export const styles = (breakpoint: number) => {
  let overideDataParentContainer: ViewStyle = {}
  let overideRightContainer: BoxProps = {}
  let overideLeftContainer: BoxProps = {}
  let overidetabbar: ViewStyle = {}
  let overidePersonalDataContainer: BoxProps = {}
  let overideCheckBoxsContainer: ViewStyle = {}
  let overideNotifyRightContainer: ViewStyle = {}
  let headerStyle = {
    height: 56,
    justifyContent: 'space-between',
    opacity: 0.9,
    padding: 16,
    borderTopEndRadius: 8,
    borderTopStartRadius: 8,
    backgroundColor: 'BACKGROUND',
  } as BoxProps

  if (breakpoint < 1000) {
    overideDataParentContainer = {
      flexDirection: 'column',
      marginStart: 0,
      marginEnd: 0,
      marginBottom: 8,
    }
    overideRightContainer = {
      marginStart: 0,
      marginEnd: 0,
      marginTop: 8,
      marginBottom: 8,
    }
    overideLeftContainer = {
      marginStart: 0,
      marginEnd: 0,
      marginTop: 8,
      marginBottom: 8,
    }
    overidePersonalDataContainer = {
      marginHorizontal: 0,
      marginBottom: 8,
      marginTop: 8,
    }
    overideCheckBoxsContainer = {
      width: 112,
    }
    overideNotifyRightContainer = {
      width: 126,
    }
  }
  if (breakpoint < 425) {
    overidetabbar = {
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      overflow: 'auto',
      paddingStart: breakpoint < 321 ? 104 : breakpoint < 361 ? 64 : breakpoint < 385 ? 48 : 0,
    } as ViewStyle
  }
  return {
    container: {
      shadowOffset: { width: 1, height: 1 },
      shadowRadius: 3,
      shadowColor: Colors.LIGHT_GREY,
      borderRadius: 8,
      borderWidth: 1,
      borderColor: Colors.BORDER_COLOR,
      zIndex: 10,
      flex: 1,
      marginVertical: 16,
      marginHorizontal: 16,
      backgroundColor: 'WHITE',
      paddingHorizontal: 16,
      paddingVertical: 16,
      overflow: 'auto',
      maxHeight: '85vh',
    } as BoxProps,
    tabbar: {
      marginTop: 25,
      backgroundColor: 'WHITE',
      justifyContent: 'center',
      alignItems: 'center',
      ...overidetabbar,
    } as BoxProps,
    dataContainer: {
      borderWidth: 1,
      borderColor: Colors.DISABLED_GREY,
      borderRadius: 8,
      flex: 1,
      marginStart: 20,
      marginEnd: 20,
      marginBottom: 40,
    } as ViewStyle,
    personalDataContainer: {
      borderWidth: 1,
      borderColor: 'DISABLED_GREY',
      borderRadius: 8,
      marginBottom: 40,
      marginHorizontal: 180,
      ...overidePersonalDataContainer,
    } as BoxProps,
    dataParentContainer: {
      flexDirection: 'row',
      justifyContent: 'space-around',
      marginStart: 25,
      marginEnd: 25,
      ...overideDataParentContainer,
    } as BoxProps,
    dataParentColumnContainer: {
      flex: 1,
      flexDirection: 'column',
      // height: '100%',
      flexShrink: 1,
    } as BoxProps,
    headerStyle: {
      ...headerStyle,
    } as BoxProps,
    headerTextStyle: {
      color: 'BLACK_GRAY_SHADE',
      fontSize: 14,
      fontWeight: 'BOLD',
      fontFamily: 'jiotype-bold',
    } as TextProps,
    listItemContainer: {
      justifyContent: 'space-between',
      flexDirection: 'row',
      height: 56,
      marginHorizontal: 16,
      alignItems: 'center',
    } as BoxProps,
    separatorStyle: { height: 1, backgroundColor: 'DISABLED_GREY' } as BoxProps,
    listItemKeyStyle: {
      color: 'CLOUDY_GREY',
      fontSize: 12,
      fontWeight: 'BOLD',
    } as TextProps,
    listItemValueStyle: {
      color: 'BLACK_SECONDARY',
      fontSize: 12,
      fontWeight: '600',
    } as TextProps,
    notificationHeaderStyle: {
      ...headerStyle,
      flexDirection: 'row',
    } as ViewStyle,
    notificationRightTextStyle: {
      color: 'GREY_MATTE',
      fontSize: 12,
      fontWeight: 'MEDIUM',
      marginHorizontal: 5,
    } as TextProps,
    checkBoxsContainer: {
      width: 176,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-around',
      ...overideCheckBoxsContainer,
    } as ViewStyle,
    notificationRightContainer: {
      width: 176,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-around',
      ...overideNotifyRightContainer,
    } as ViewStyle,
    leftCardContainer: {
      borderWidth: 1,
      borderColor: 'DISABLED_GREY',
      borderRadius: 8,
      // flex: 1,
      marginEnd: 20,
      marginBottom: 40,
      // height: '100%',
      ...overideLeftContainer,
    } as BoxProps,
    rightCardContainer: {
      borderWidth: 1,
      borderColor: 'DISABLED_GREY',
      borderRadius: 8,
      // flex: 1,
      marginStart: 20,
      marginBottom: 40,
      marginLeft: 16,
      // height: '100%',
      ...overideRightContainer,
    } as BoxProps,
    loaderView: {
      justifyContent: 'center',
      alignItems: 'center',
      height: 550,
    } as ViewStyle,
    errorView: {
      justifyContent: 'center',
      alignSelf: 'center',
      color: 'red',
    } as ViewStyle,
    emptyView: { height: 33 } as ViewStyle,
    emptyViewLarge: { height: 75 } as ViewStyle,
    retryViewStyle: {
      justifyContent: 'center',
      alignItems: 'center',
      height: 550,
    } as BoxProps,
  }
}
